/*************************
 * Author : Matthieu ROBIN
 *************************/
import React, { FunctionComponent } from "react";

import CarDetails from "../components/CarDetails";
import { useParams } from "react-router";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { useAppSelector } from "../app/hooks";
import { selectCar } from "../slices/cars-slice";

const CarDetailsPage: FunctionComponent = () => {
  const theme = useTheme();
  const params = useParams();
  const car = useAppSelector(selectCar(params.id));
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    car && (
      <Dialog
        open={true}
        maxWidth="md"
        fullWidth
        fullScreen={fullScreen}
        scroll="body"
      >
        <CarDetails car={car} />
      </Dialog>
    )
  );
};

export default CarDetailsPage;
